import { onMounted, onUnmounted, ref } from 'vue'

const DEFAULT_GROUP = 'adaptive-card-dropdowns'

export function useExclusiveOpenGroup(instanceId: string, groupId: string = DEFAULT_GROUP) {
  const isOpen = ref(false)
  const eventName = `ac:exclusive-open:${groupId}`

  function setOpen(nextOpen: boolean) {
    isOpen.value = nextOpen
    if (!nextOpen) return
    window.dispatchEvent(new CustomEvent(eventName, { detail: { id: instanceId } }))
  }

  function close() {
    isOpen.value = false
  }

  function handleOtherOpened(event: Event) {
    const openedId = (event as CustomEvent<{ id?: string }>).detail?.id
    if (!openedId || openedId === instanceId) return
    close()
  }

  onMounted(() => {
    window.addEventListener(eventName, handleOtherOpened as EventListener)
  })

  onUnmounted(() => {
    window.removeEventListener(eventName, handleOtherOpened as EventListener)
  })

  return {
    isOpen,
    setOpen,
    close,
  }
}
